export var CODE_VALUE = 'x00080100';
export var CODING_SCHEME_DESIGNATOR = 'x00080102';
export var CODING_SCHEME_VERSION = 'x00080103';
export var CODE_MEANING = 'x00080104';
export var SOP_CLASS_UID = 'x00080016';
export var PATIENT_ID = 'x00100020';
export var WAVEFORM_ORIGINALITY = 'x003a0004';
export var NUMBER_OF_WAVEFORM_CHANNELS = 'x003a0005';
export var NUMBER_OF_WAVEFORM_SAMPLES = 'x003a0010';
export var SAMPLING_FREQUENCY = 'x003a001a';
export var MULTIPLEX_GROUP_LABEL = 'x003a0020';
export var CHANNEL_SENSITIVITY = 'x003a0210';
export var CHANNEL_SENSITIVITY_CORRECTION_FACTOR = 'x003a0212';
export var CHANNEL_BASELINE = 'x003a0213';
export var WAVEFORM_BITS_STORED = 'x003a021a';
export var WAVEFORM_BITS_ALLOCATED = 'x54001004';
export var WAVEFORM_SAMPLE_INTERPRETATION = 'x54001006';
export var WAVEFORM_SEQUENCE = 'x54000100';
export var CHANNEL_DEFINITION_SEQUENCE = 'x003a0200';
export var CHANNEL_SOURCE = 'x003a0208';
export var CHANNEL_SENSITIVITY_UNITS = 'x003a0211';
export var SAMPLE_OFFSET = 'x54001010';
//# sourceMappingURL=dicomTags.js.map